import { keyframes, styled } from "../../styles";

// Gentle pulse so the placeholder trace reads as "loading" (the skeleton
// shimmer equivalent, applied to the ghost ECG line).
const pulse = keyframes({
  "0%, 100%": { opacity: 0.35 },
  "50%": { opacity: 0.7 },
});

export const PulseTrace = styled("polyline", {
  animation: `${pulse} 1.4s ease-in-out infinite`,
});
